import { render, staticRenderFns } from "./UpOrder.vue?vue&type=template&id=e3bbdac8&scoped=true&"
import script from "./UpOrder.vue?vue&type=script&lang=js&"
export * from "./UpOrder.vue?vue&type=script&lang=js&"
import style0 from "./UpOrder.vue?vue&type=style&index=0&id=e3bbdac8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3bbdac8",
  null
  
)

export default component.exports